import React from "react";
import cx from "apps/website/utils/misc/cx";

import LandingPageRecipeCarouselItem, {
  ILandingPageRecipeCarouselItem,
} from "./components/LandingPageRecipeCarouselItem";

export interface ILandingPageRecipeCarousel {
  items: ILandingPageRecipeCarouselItem[];
  className?: string;
}

const LandingPageRecipeCarousel = ({ items, className }: ILandingPageRecipeCarousel) => (
  <div className={cx("w-full lg:max-w-[850px]", className)}>
    <div className="grid grid-cols-2 grid-flow-row gap-5">
      { items.map((item) => (
        <LandingPageRecipeCarouselItem key={item.title} {...item} />
      )) }
    </div>
  </div>
);

export default LandingPageRecipeCarousel;
